/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelDestinatarioRicercaDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CercaDestinatariComunicazioneRequestParams {
    pageable: Pageable;
    q?: string;
    comuneId?: string;
}


export interface ComunicazioniManualiDestinatariServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Cerca cittadini destinatari di una comunicazione (SUPERADMIN, OP_COMUNE).
     * Ricerca per nome, cognome o email (sottostringa, senza distinzione fra maiuscole e minuscole) fra i cittadini che il caller puo\&#39; contattare. Con &#x60;q&#x60; assente o di meno di 2 caratteri la pagina e\&#39; vuota. Ordine fisso cognome, nome; pagina di massimo 20 righe.  Perimetro: mai anonimizzati, bloccati o con account non attivato. Per un OP_COMUNE solo cittadini con almeno una pratica su un bando del comune di perimetro (&#x60;comune_id&#x60;: obbligatorio se gestisce piu\&#39; comuni, default se ne gestisce uno). Per un SUPERADMIN &#x60;comune_id&#x60; e\&#39; opzionale e, se presente, applica lo stesso vincolo.  L\&#39;email e\&#39; restituita per intero (&#x60;email&#x60;); &#x60;n_dispositivi&#x60; dice a quanti dispositivi arriverebbe una push.  Risposte: - 200: &#x60;Page&lt;DestinatarioRicercaDTO&gt;&#x60;. - 400: &#x60;comune_id&#x60; mancante per un OP_COMUNE con piu\&#39; comuni. - 403: caller ne\&#39; SUPERADMIN ne\&#39; OP_COMUNE. - 404: comune inesistente o fuori dai comuni gestiti.
     * @endpoint get /api/v1/gestione/comunicazioni-manuali/destinatari
* @param requestParameters
     */
    cercaDestinatariComunicazione(requestParameters: CercaDestinatariComunicazioneRequestParams, extraHttpRequestParams?: any): Observable<PagedModelDestinatarioRicercaDTO>;

}
